module.exports = __webpack_public_path__ + "static/kodie-7a53795c91febc744791fb078043a984.jpg";